import { Action } from '@ngrx/store';

export class TrackingActions implements Action {

    public static updateDataPage = '[Tracking] update_data_page';
    public static trackFormEvent = '[Tracking] tracking_form_event';
    public static trackLoginEvent = '[Tracking] tracking_login_event';
    public static trackTokenEvent = '[Tracking] tracking_token_event';
    public static sendTrackLogin = '[Tracking] send_track_login';
    public static sendOrderInformation = '[Tracking] send_order_information';
    public static sendFirstLoginActivated = '[Tracking] send_first_login_activated';

    public static trackErrorMessages = '[Tracking] track_error_messages';

    public static trackEventsToGA = '[Tracking] track_events_to_GA';
    public static trackEvents = '[Tracking] track_events_to_segment';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
